import Api from './api.service'

export default {
  createNewsFeed (object) {
    return Api().post('newsFeed/create', object)
  },
  updateNewsFeed (object) {
    return Api().put('newsFeed/edit/' + object.id, object.object)
  },
  newsFeedList (filter) {
    return Api().get('newsFeed/get', { params: filter })
  },
  getNewsFeed (id) {
    return Api().get('newsFeed/get/' + id)
  }
}